import { Validator } from '@vista-digital/validator';
import { nonEmptyStringValidator } from './string';
const internalActionValidator = (internalActions) => internalActions ? Validator.oneOf(internalActions) : nonEmptyStringValidator;
const customPartValidator = (internalActions) => Validator.object({
    text: nonEmptyStringValidator,
    iconName: Validator.optional(nonEmptyStringValidator),
    className: Validator.optional(nonEmptyStringValidator),
    href: Validator.optional(nonEmptyStringValidator),
    onClick: Validator.optional(Validator.fn()),
    openInNewTab: Validator.optional(Validator.boolean()),
    internalAction: Validator.optional(internalActionValidator(internalActions))
});
const partValidator = (internalActions) => Validator.any([
    nonEmptyStringValidator,
    customPartValidator(internalActions)
]);
export const displayTextLabelValidator = Validator.any([
    partValidator(),
    Validator.array({ items: partValidator() })
]);
export const getDisplayTextLabelValidator = (internalActions) => Validator.any([
    partValidator(internalActions),
    Validator.array({ items: partValidator(internalActions) })
]);
